<div
  class="modal fade show d-block"
  tabindex="-1"
  [ngStyle]="{ display: show ? 'block' : 'none' }"
  role="dialog"
  *ngIf="show"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Email Meeting Summary</h5>
        <button type="button" class="btn-close" (click)="cancel()"></button>
      </div>

      <div class="modal-body">
        <app-email-tags [emails]="emails" (emailListChange)="emailList($event)"></app-email-tags>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-dark"
          [disabled]="!isValid"
          (click)="sendEmail()"
        >
          Send Email
        </button>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</div>
